module.exports = __webpack_public_path__ + "static/img/A21.3e35490e.jpg";